import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const page = css`
    padding: 0;
  `;

  const card = css`
    border-radius: 4px;
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
    margin-bottom: 16px;
  `;

  const cardHeader = css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.navy["1"]};
    padding: 0px 16px;
  `;

  const headerRow = css`
    padding: 20px 0 0 20px;
    align-items: center;
  `;

  const title = css`
    font-family: "Open Sans", sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: ${theme.colors.navy["1"]};
  `;

  const subtitle = css`
    font-size: 14px;
    padding-top: 4px;
    color: ${theme.colors.navy["1"]};
  `;

  const hr = css`
    margin-left: 30px;
    margin-right: 30px;
  `;

  const rightAlignColumns = css`
    .extendedHoursCol,
    .effectiveRateCol,
    .revenueCol,
    .effectiveCostCol,
    .totalCostCol,
    .grossProfitCol {
      text-align: right;
    }

    .cellCol1 > div,
    .cellCol2 > div,
    .cellCol3 > div,
    .cellCol4 > div,
    .cellCol5 > div,
    .cellCol6 > div {
      justify-content: flex-end !important;
    }

    tbody[data-target=".multi-collapsetotal"] td {
      border-top: 3px solid ${theme.colors.navy["1"]};
    }

    tbody[data-target=".multi-collapsetotal"],
    tbody[data-target=".multi-collapsemargin"] {
      background-color: ${theme.colors.white} !important;
      border-top: none !important;
    }

    tbody[data-target=".multi-collapsetotal"] tr {
      padding-bottom: 3px;
    }

    tbody[data-target=".multi-collapsemargin"] tr {
      padding-top: 4px;
    }

    tbody[data-target=".multi-collapsemargin"] td {
      border: none;
    }
  `;

  const pricingTabs = css`
    .nav-tabs {
      border-bottom: 1px solid ${theme.colors.gray["2"]};
    }

    .nav-tabs .nav-link {
      background-color: ${theme.colors.white};
      border: none;
      border-bottom: 3px solid transparent;
      color: ${theme.colors.navy["1"]};
      font-weight: 600;
      padding-top: 4px;
    }

    .nav-tabs .nav-link.active {
      background-color: ${theme.colors.white};
      border: none;
      border-bottom: 3px solid #418172;
      color: ${theme.colors.navy["1"]};
    }

    .nav-tabs .nav-link:hover:not(.active) {
      border: none;
      border-bottom: 3px solid ${theme.colors.gray["2"]};
    }

    .tab-content > .tab-pane {
      padding: 0;
    }
  `;

  const tabContent = css`
    padding-top: 16px;
    background-color: ${theme.colors.white};
  `;

  return {
    page,
    card,
    cardHeader,
    headerRow,
    title,
    subtitle,
    hr,
    rightAlignColumns,
    pricingTabs,
    tabContent,
  };
};

export default useStyles;
